<template>
  <div class="rj-page-card">
    <div class="rj-page-card__title">
      水单附件
    </div>
    <div class="rj-page-card__content">
      <el-table
        v-loading="tableLoading"
        :data="form.attachmentList"
        border
        style="width: 100%"
        row-key="id"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55" align="left" /> -->
        <el-table-column prop="fileName" label="文件名称" align="left">
          <template v-slot="{ row }">
            <el-button
              type="text"
              @click="openContract(row)"
            >
              {{ row.fileName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="上传人" align="left" />
        <el-table-column prop="createTime" label="上传时间" align="left" />
        <el-table-column prop="pname" label="操作" align="left" fixed="right">
          <template v-slot="{ row }">
            <el-button
              type="text"
              @click="downOneFile(row)"
            >
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    </div>
  </div>
</template>
<script type="es6">
import axios, {
  getAttachmentListByContractId,
  attachmentGetToken,
  uploadAfterSaveInfo,
  deleteByContractIdAndAttachmentId,
  electronicSignature,
  printContractPDF,
  getUrlByFileID
} from '@/API';
import { getAliOSSDownloadInfo } from '@/API/international';

export default {
  data () {
    return {
      multipleSelection: [],
      fileList: [],
      tableLoading: false,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: ''
    };
  },
  props: {
    tableData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    form: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  components: {},
  computed: {},
  methods: {
    searchFiles () {
      this.tableLoading = true;
      getAttachmentListByContractId(this.contractNum).then((res) => {
        let json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    downOneFile (row) {
      if (Number(row.cloudAddress) === 1) {
        getAliOSSDownloadInfo(row.fileToken).then(({ status, data }) => {
          if (Number(status) === 200) {
            console.log(data);
            this.fileserveDownUrl = data.fileInfo.url;
            this.$nextTick(() => {
              this.$refs.downTag.click();
            });
          }
        }).catch(() => {
        });
      } else {
        if (row.fileUrl) {
          location.href = row.fileUrl;
        } else {
          this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
          this.$nextTick(() => {
            this.$refs.downTag.click();
          });
        }
      }
    },
    downzipFile (token, url) {
      this.fileserveDownUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    submitfile (files) {
      this.tableLoading = true;
      uploadAfterSaveInfo(files).then((res) => {
        let json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.searchFiles();
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    uploadaction (upload) {
      let form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      let myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.fileList.push(myfile);
      axios.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.submitfile([{
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID,
            contractId: this.form.contractNum
          }]);
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    removeFile (row) {
      this.tableLoading = true;
      deleteByContractIdAndAttachmentId({
        contractId: row.contractId,
        attachmentId: row.id
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.searchFiles();
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    goEsing () {
      electronicSignature(this.form.contractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$refs.doEsign.openWindow(json.data);
        }
      }).catch(() => {

      });
    },
    CompleteEsign (val) {
      if (val.isComplete) {
        this.searchFiles();
      }
    },
    printPdf () {
      printContractPDF(this.form.contractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.fileserveDownUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(json.data)}`;
          this.$nextTick(() => {
            this.$refs.downTag.click();
          });
        }
      }).catch(() => {

      });
    },
    openContract (row) {
      if (Number(row.cloudAddress) === 1) {
        getAliOSSDownloadInfo(row.fileToken).then(({ status, data }) => {
          if (Number(status) === 200) {
            console.log(data);
            window.open(data.fileInfo.url);
          }
        }).catch(() => {
        });
      } else {
        if (row.fileUrl) {
          window.open(row.fileUrl);
        } else {
          getUrlByFileID(row.fileToken).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              window.open(json.data);
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      }
    }
  },
  mounted () {
    // this.searchFiles();
    this.initToken();
  }
};
</script>
